import { useState } from "react";
import { useQuery } from "react-query";
import { createStreamPath, createStreamType, deleteStream, fetchLists, getProjectsWell, getTypeOfStream, resetStream, startStream, updateNameStream, updateStreamPath, updateStreamType } from "../services/API/StreamingAdminApi";


const useStreamingAdmin = () => {
    const [projects, setProjects] = useState([]);
    const [clients, setClients] = useState([]);
    const [platforms, setPlatforms] = useState([]);
    const [enabledList, setEnabledList] = useState(true);
    const [modalInfoError, setModalInfoError] = useState(false);
    const dataUser = JSON.parse(sessionStorage.getItem("userData"));
    const token = dataUser?.token;
    const table_data = dataUser?.table;
    const email_data = dataUser?.user_email;

    // State to projectsWell
    const [clientToWell, setClientToWell] = useState('');
    const [projectToWell, setProjectToWell] = useState('');
    const [productToStreamType, setProductToStreamType] = useState('');
    const [wellNames, setWellNames] = useState([]);
    const [typesOfStreams, setTypesOfStreams] = useState([]);


    // State to manipulate stream
    const [createParams, setCreateParams] = useState(null);
    const [startParams, setStartParams] = useState(null);

    //UseQuery
    const { isLoading, isError } = useQuery(
        ['list', table_data, email_data, token],
        () => fetchLists(table_data, email_data, token),
        {
            enabled: enabledList,
            retry: 2,
            onError: () => {
                setEnabledList(false)
                setModalInfoError(true)
            },
            onSuccess: (data) => {
                setEnabledList(false)
                setProjects(data.proyects);
                setPlatforms(data.platforms);
                setClients(data.clients);
            }
        }
    );


    const { isLoadingProjectsWell, isErrorProjectsWell, refetch: refetchProjectsWell } = useQuery(
        ['projectsWell'],
        () => getProjectsWell(clientToWell, projectToWell),
        {
            enabled: false,
            retry: 2,
            onError: (error) => {
                console.log(error);
            },
            onSuccess: (response) => {
                setWellNames(response.data.well_names);
            }
        }
    );

    const { isLoadingTypeOfStream, isErrorTypeOfStream, refetch: refetchTypeOfStream } = useQuery(
        ['projectsWell', productToStreamType],
        () => getTypeOfStream(productToStreamType),
        {
            enabled: false,
            retry: 2,
            onError: (error) => {
                console.log(error);
            },
            onSuccess: (response) => {
                setTypesOfStreams(response.data.stream_types);
            }
        }
    );

    const triggerCreateStream = async ({ product, client, project, streamType, wellName, streamPath }) => {
        try {
            const response = await createStreamPath(product, client, project, streamType, wellName, streamPath);
            return response; // Devuelve la respuesta para manejarla en el componente
        } catch (error) {
            console.error("Error creating stream:", error.message);
            throw new Error("Failed to create streaming.");
        }
    };


    const triggerStartStream = async ({ product, client, project, streamType, wellName }) => {
        try {
            const response = await startStream(product, client, project, streamType, wellName);
            return response;
        } catch (error) {
            console.error("Error starting stream:", error.message);
            throw new Error("Failed to start streaming.");
        }
    };

    const triggerDeleteStream = async ({ product, client, project, streamType, wellName }) => {
        try {
            const response = await deleteStream(product, client, project, streamType, wellName);
            return response;
        } catch (error) {
            console.error("Error starting stream:", error.message);
            throw new Error("Failed to start streaming.");
        }
    };

    const triggerUpdateStreamName = async ({ product, client, project, streamType, wellName, newStreamName }) => {
        try {
            const response = await updateNameStream(product, client, project, streamType, wellName, newStreamName);
            return response;
        } catch (error) {
            console.error("Error starting stream:", error.message);
            throw new Error("Failed to start streaming.");
        }
    };

    const triggerUpdateStreamPath = async ({ product, client, project, streamType, wellName, newStreamPath }) => {
        try {
            const response = await updateStreamPath(product, client, project, streamType, wellName, newStreamPath);
            return response;
        } catch (error) {
            console.error("Error starting stream:", error.message);
            throw new Error("Failed to start streaming.");
        }
    };

    const triggerResetStream = async ({ product, client, project, streamType, wellName }) => {
        try {
            const response = await resetStream(product, client, project, streamType, wellName);
            return response;
        } catch (error) {
            console.error("Error starting stream:", error.message);
            throw new Error("Failed to start streaming.");
        }
    };

    const triggerCreateStreamType = async (product, newStreamType, fields) => {
        try {
            const response = await createStreamType(product, newStreamType, fields);
            return response;
        } catch (error) {
            console.error("Error starting stream:", error.message);
            throw new Error("Failed to start streaming.");
        }
    };

    const triggerModifyStreamType = async (product, streamType, fields) => {
        try {
            const response = await updateStreamType(product, streamType, fields);
            return response;
        } catch (error) {
            console.error("Error starting stream:", error.message);
            throw new Error("Failed to start streaming.");
        }
    };


    return {
        token,
        dataUser,
        clients,
        email_data,
        projects,
        platforms,
        isLoading,
        isError,
        clientToWell,
        projectToWell,
        wellNames,
        typesOfStreams,
        productToStreamType,
        createParams,
        setClientToWell,
        setProjectToWell,
        setProductToStreamType,
        setTypesOfStreams,
        setCreateParams,
        setStartParams,
        refetchProjectsWell,
        refetchTypeOfStream,
        triggerStartStream,
        triggerCreateStream,
        triggerDeleteStream,
        triggerUpdateStreamName,
        triggerUpdateStreamPath,
        triggerResetStream,
        triggerCreateStreamType,
        triggerModifyStreamType
    }
}

export { useStreamingAdmin };